import { render, staticRenderFns } from "./project-monthly-choose-contact.vue?vue&type=template&id=31fb2827&scoped=true&"
import script from "./project-monthly-choose-contact.vue?vue&type=script&lang=js&"
export * from "./project-monthly-choose-contact.vue?vue&type=script&lang=js&"
import style0 from "./project-monthly-choose-contact.vue?vue&type=style&index=0&id=31fb2827&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fb2827",
  null
  
)

export default component.exports